import {
  Box,
  BoxProps,
  Flex,
  Grid,
  Heading,
  Icon,
  OptionTile,
  smBumps,
  xsBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { CoverLevelOption } from '../../../../domain'
import {
  TKeyBuilder,
  tProduct,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import {
  getHelpContentBaseUrl,
  PaymentScheduleType,
  useConfig,
} from '../../../../state/configuration'
import { useProduct } from '../../../product/ProductProvider'
import { HelpFlexAnchor } from '../../links'

export interface PaymentScheduleProps extends BoxProps {
  tKey: TKeyBuilder
  value?: PaymentScheduleType
  onChange: (value: PaymentScheduleType) => void
  coverOptions: CoverLevelOption[]
  loading?: boolean
}

const key = 'payment-schedule'

export const PaymentScheduleSelection: FunctionComponent<PaymentScheduleProps> = ({
  tKey,
  value,
  onChange,
  coverOptions,
  loading,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const {
    product: { payment },
  } = useProduct()

  const contentBaseUrl = useConfig(getHelpContentBaseUrl)
  const header = t(tKey(key, 'header'), { defaultValue: null })

  return coverOptions.length > 1 ? (
    <Box display='flex' flexDirection='column' gap={smBumps} width={1} {...props}>
      {header && (
        <Flex width={1}>
          <Heading variant='h4' as='h4' typoSize='md'>
            {header}
          </Heading>
          {payment?.helpLink && (
            <HelpFlexAnchor
              variant='highlight'
              borderRadius='50%'
              justifyContent='center'
              ml={smBumps}
              p={1}
              href={`${contentBaseUrl}/${key}.html`}
            >
              <Icon icon='help' size='medium' />
            </HelpFlexAnchor>
          )}
        </Flex>
      )}
      <Grid
        gridTemplateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)']}
        width={1}
        gap={xsBumps}
      >
        {coverOptions.map((it) => (
          <OptionTile
            key={it.paymentScheduleType}
            name={key}
            value={it.paymentScheduleType}
            text={t(tProduct('payment-schedules', it.paymentScheduleType))}
            onSelect={onChange}
            checked={value === it.paymentScheduleType}
            disabled={loading}
          />
        ))}
      </Grid>
    </Box>
  ) : null
}
